import { render, staticRenderFns } from "./RoofLayoutPrintPage2.vue?vue&type=template&id=b5955398"
import script from "./RoofLayoutPrintPage2.vue?vue&type=script&lang=js"
export * from "./RoofLayoutPrintPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports